import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'newDocType';

const documentTypeService = {
  getDocumentType: (id) => {
    return request({
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  getDocumentTypes: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/documenttypes`,
      data,
    });
  },

  allDocumentTypes: () => {
    return request({
      resource: `${baseURL}/documents/allDocumentTypes`,
    });
  },

  updateDocumentType: (data, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  uploadFile: (file, id, userId) => {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('userId', userId);

    return request({
      method: Methods.POST,
      resource: `${baseURL}/uploadFile/${encodeURIComponent(id)}`,
      formData: true,
      data: formData,
    });
  },

  deleteFile: (id, userId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/deleteFile/${encodeURIComponent(id)}`,
      data: { userId },
    });
  },

  /* getDocumentTypes: () => {
    return request({
      resource: `${baseURL}/documenttypes`,
    });
  },*/
};

export default documentTypeService;
